export default "__VITE_ASSET__BW4HKd3m__"